var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"fade"}},[(_vm.shown)?_c('section',{ref:"wrapper",staticClass:"step-wrapper max-w",class:_vm.classes,attrs:{"id":_vm.id}},[_c('div',{staticClass:"content"},[_vm._t("default")],2)]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }